import { ICONS_SET } from '@pro/web-common/constants/icons';


export const getIconDataById = (iconId) => ICONS_SET.find(({ id }) => id === iconId);
